import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';


const QuickActionCard = ({ className = '' }) => {
  const quickActions = [
    {
      title: 'Today\'s Goals',
      description: 'Continue your daily progress',
      icon: 'Target',
      path: '/today',
      color: 'primary'
    },
    {
      title: 'View History',
      description: 'Review past achievements',
      icon: 'History',
      path: '/history',
      color: 'secondary'
    }
  ];

  return (
    <div className={`bg-card border border-border rounded-lg p-4 shadow-gentle ${className}`}>
      <div className="flex items-center space-x-2 mb-4">
        <Icon name="Zap" size={20} className="text-accent" />
        <h3 className="font-heading font-semibold text-foreground">
          Quick Actions
        </h3>
      </div>
      <div className="space-y-3">
        {quickActions?.map((action, index) => (
          <Link
            key={index}
            to={action?.path}
            className="flex items-center space-x-3 p-3 rounded-lg border border-border hover:bg-muted hover:shadow-gentle-hover transition-all duration-200 animate-spring group"
          >
            <div className={`p-2 rounded-lg ${
              action?.color === 'primary' ? 'bg-primary/10' : 'bg-secondary/10'
            }`}>
              <Icon 
                name={action?.icon} 
                size={18} 
                className={action?.color === 'primary' ? 'text-primary' : 'text-secondary'}
              />
            </div>
            <div className="flex-1">
              <h4 className="font-medium text-foreground group-hover:text-primary transition-colors duration-200">
                {action?.title}
              </h4>
              <p className="text-sm text-muted-foreground">
                {action?.description}
              </p>
            </div>
            <Icon 
              name="ChevronRight" 
              size={16} 
              className="text-muted-foreground group-hover:text-primary transition-colors duration-200"
            />
          </Link>
        ))}
      </div>
      {/* Motivational Quote */}
      <div className="mt-4 pt-4 border-t border-border">
        <div className="text-center">
          <p className="text-sm text-muted-foreground italic">
            "Progress, not perfection, is the goal."
          </p>
        </div>
      </div>
    </div>
  );
};

export default QuickActionCard;